module.exports = __webpack_public_path__ + "static/media/ghuchha.d7bc32d4.ogg";